<template>
  <div
    class="week-days"
    :class="{
      'is-invalid': invalid,
      'grow': grow,
    }"
  >
    <div class="c-input-label">
      Дни недели
      <div class="c-input-label-fullname">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Дни недели',
            placement: 'bottom',
          }"
          size="iconic"
          icon="info"
        />
      </div>
    </div>

    <div class="days">
      <div
        v-for="(day, i) in days"
        :key="i"
        class="day"
        :class="{
          active: value.includes(i),
        }"
        @click="toggle(i)"
      >
        {{ day }}
      </div>
    </div>

    <error-feedback v-if="error" :text="error"></error-feedback>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CButton, ErrorFeedback },
  props: ["value", "invalid", "error", "grow"],
  data() {
    return {
      days: ["пн", "вт", "ср", "чт", "пт", "сб", "вс"],
    };
  },
  methods: {
    toggle(dayIndex) {
      let value;
      if (this.value.includes(dayIndex)) {
        value = this.value.filter((i) => i !== dayIndex);
      } else {
        value = [...this.value, dayIndex];
      }
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";

.days {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -10px;
  margin-right: -5px;
}

.day {
  width: 43px;
  height: 30px;
  border: 1px solid #d3d8df;
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #8e9cbb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-right: 5px;

  &.active,
  &:hover {
    color: #333333;
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      border: 2px solid #ff238d;
      border-radius: 50px;
    }
  }
}

.grow .day {
  width: auto;
  flex-grow: 1;
}
</style>
